export const prompts = {
  "simpleClassifier": `
  Você vai classificar a última parte de uma conversa pra mim.
  Essa conversa é gerada de uma transcrição de pessoas que estão aprendendo inglês, então seja compreensivo, pois tem muitos erros de transcrição e pronúncia.

Categorias de feedback:
- "transcription_error": Use esta categoria para frases sem estrutura suficiente, sem sentido claro ou inutilizáveis para o aprendizado.
- "naturality_help": Para quando vc perceber que a pessoa está procurando palavras, ou strugling com expressões mais naturais.
- "too_simple": Use esta para frases muito básicas ou comuns que não justificam correção ou elogio.
- "positive": Use esta para frases compostas e fluentes. Não basta ser correta, tem que ter alguma coisa avançada.
- "grammar_error": Para frases com claros erros gramaticais.

Regras adicionais:
- a classe mais importante é naturaliy_help, se couber, assinale essa classe.
- Frases com hesitação ou repetição ainda podem ser "positivas" conforme mostrado pela intenção.

Responda apenas com uma das palavras-chave: "transcription_error", "too_simple", "positive", "grammar_error", "naturality_help".

Exemplo 1:
Entrada: "Últimas mensagens: - Would you join? [positive] Avaliar: - I can't. I'm already very busy, full of things, sorry. [?]"
não é pq a frase é longa que um "positive", sempre que possível tente dar uma dica, aqui caberia ensinar a expressão my plate is full por exemplo entao responda: "naturality_help"

Exemplo 2:
Entrada: "Últimas mensagens: - I go to the store yesterday. [grammar_error] Avaliar: - What did you buy? [?]"
é quase um "positive" mas é muito pouco pra isso, é melhor indicar que existem expressões mais naturais pra isso com: "naturality_help"

Exemplo 3:
Entrada: "Últimas mensagens: - Hello guys, good morning. [too_simple] Avaliar: - Morning, morning. [?]"
aqui vc retornaria: "too_simple"

Exemplo 4:
Entrada: "Últimas mensagens: - How were whsa ttattai it? [transcription_error] Avaliar: - It was awful back then, but now we laugh about it. [?]"
aqui vc retornaria somente: "positive"

Exemplo 5:
Entrada: "Últimas mensagens: - What is you thinking? [grammar_error] Avaliar: - I actually was like, I don't want to relate with him for now. [?]"
"What is" ta errado, mas não é nosso foco. percebe que a última frase carece de vocabulário e clareza mas do que gramática então vc retornaria somente: "naturality_help"

Exemplo 6:
Entrada: "Últimas mensagens: - Did you see the that? [positive] Avaliar: - Yeah, I saw. [?]"
Aqui vc avalia "Yeah, I saw" q ta faltando it no final. então vc retornaria: "grammar_error"

Exemplo 7:
Entrada: "Últimas mensagens: - You made the question. Can I skip all or not? [transcription_error] Avaliar: - Lucas, which I'll never forget the time when... she broke his arm twice, you know. [?]"
aqui vc retornaria: "transcription_error"

`,
  "reasoningclassifier": `
You are an evaluator tasked with analyzing the last sentence from a conversation between English learners. You will proceed step by step, but at the end, return only a structured JSON object. Your output will guide feedback generation, so consistency is critical.

---

**Step 1: Does the final sentence answer a question?**
If yes, identify the question type. Use one of the following exact values:
- "yes_no"
- "wh"
- "past_yes_no"
- "past_wh"
- "present"
- "none" (if there is no question to answer)

**Step 2: Write a fluent and natural continuation for the conversation based on the last sentence.**

**Step 3: Extract *verbatim* the last sentence as it appears in the input.**

**Step 4: Is the sentence comprehensible, or does it contain major transcription errors?**
Return true if comprehensible; false if corrupted or nonsensical.

**Step 5: Compared to your step2, is the sentence as natural as expected, or could it benefit from a tip for improved naturalness?**
Return true if natural enough; false if awkward or robotic.

**Step 6: If the sentence answers a question, was the response grammatically appropriate?**
Example of incorrect match:
Q: "Do you have a car?" → A: "Yes, I have."
Return true if the answer is appropriate; false otherwise.

**Step 7: Does the sentence contain grammar mistakes?**
Return true if there is any grammar mistake; false if it's correct.

**Step 8: Does the sentence show complexity and vocabulary that is praiseworthy for a learner?**
Return true if it's above average in structure or vocabulary; false otherwise.

---

**Output format:**
Return only the following JSON object, exactly in this structure, with booleans as true or false. Do not include explanations or comments.

{
  "answers": {
    "responds_to_question": true,
    "question_type": "past_wh",
    "natural_followup": "That's good to know. Did you enjoy it?",
    "last_sentence": "I went to the concert.",
    "transcription_reliable": true,
    "natural_enough": true,
    "answered_appropriately": true,
    "grammar_mistake": false,
    "praiseworthy_complexity": false,
    "sentence_evaluated": "I went to the concert."
  }
}
  `,
  "vetorclassifier":
  `{
    "contexto": "Você está acompanhando duas pessoas praticando inglês online. Vai receber a transcrição imperfeita do áudio da conversa mais recente.",
    "tarefa": "Classifique a última frase com base em quatro dimensões binárias: Erro de Transcrição, Baixa naturalidade, Erros de Gramática e Complexidade.",
    "categorias": {
      "erro de transcricao": "Avalia o quão provável é que a transcrição tenha falhado. Se houver palavras sem sentido, pode ter sido um erro de pronúncia, e então dê uma nota alta.",
      "Baixa naturalidade": "Avalia o quão fluída e espontânea a frase soa. Se a frase for excessivamente formal ou parecer 'robotizada', pontue mais alto. Frases naturais, como um nativo falaria, devem ter pontuação baixa.",
      "Erros de Gramática": "A frase contém erros gramaticais como: conjugação incorreta, uso incorreto de auxiliares (do/does/did), respostas incorretas a perguntas com 'do/does/did', ou uso incorreto de tempos verbais. Dê uma pontuação de 0 se não houver erros e uma pontuação de 2 se houver erros graves.",
      "complexidade": "Avalia a riqueza e a estrutura da frase. Frases curtas e simples, receberão uma pontuação mais baixa, enquanto frases longas, com variedade lexical e estrutura, terão uma pontuação mais alta."
    },
    "tips": "Atenção: você só deve avaliar a última frase. O que vem antes é contexto e pode estar incorreto, mas você deve ignorar e avaliar apenas a última frase.",
    "exemplo_de_aplicacao": [
      {
        "input": "Últimas mensagens:\n- Hello.\n- Hello, guys.\n\nAvaliar:\n- Good morning",
        "retorno": [0, 0, 0, 0],
        "explicacao": "Não há nada de errado com 'Good morning', mas a frase é muito simples, então a pontuação para complexidade será 0."
      },
      {
        "input": "Últimas mensagens:\n- I go to the store yesterday.\n\nAvaliar:\n- What did you buy?",
        "retorno": [0, 1, 0, 1],
        "explicacao": "'What did you buy?' provavelmente ta transcrita corretamente (0 de erro). Mas podia ser dita com mais naturalidade com got ou outra coisa (1). A frase 'I go to the store yesterday' tem q ser ignorada pois a última não tem erro então é 0 pra erro. A frase é simples, com complexidade 1."
      },
      {
        "input": "Últimas mensagens:\n- So, yeah I'm really into reading.\n- That's cool, that's cool.\n- What about you, do you have any favourite books?\nAvaliar:\n- I have, yeah, it's Harry Potter.",
        "retorno": [0, 1, 2, 0],
        "explicacao": "transcrição ok 0, naturalidade baixa 1, e responder 'I have' a uma pergunta 'Do' de forma é incorreto, já que a estrutura correta seria 'Yes, I do' então, 2. A frase é simples, com complexidade 0."
      },
      {
        "input": "Últimas mensagens:\n- Can you help me?\n\nAvaliar:\n- Yes, I can help you.",
        "retorno": [0, 1, 0, 0],
        "explicacao": "A transcrição parece correta (0 de erro), a frase podia ser mais natural (1 de baixa naturalidade), a gramática está correta (0 de erro). A complexidade é 0."
      },
      {
        "input": "Últimas mensagens:\n- I have never seen that movie.\n\nAvaliar:\n- No, I didn't never saw it.",
        "retorno": [0, 1, 2, 0],
        "explicacao": "O erro gramatical aqui está na dupla negação, 'didn't never', que não é correta. A frase correta seria 'No, I have never seen it'. A pontuação para 'Erros de Gramática' é 2, pois o erro é significativo. A frase é simples, com complexidade 0."
      }
    ]
  }`,
"grammar_error":
  `{
  "description": "Encontre o erro gramatical nas transcrições de áudio de conversas em inglês. O feedback deve ser breve e formatado em HTML para destacar a correção.",
  "instructions": [
    "Você receberá uma transcrição imperfeita do áudio da conversa. Ignore erros de digitação e repetições, pois esses são naturais na fala.",
    "O feedback deve ser curto e direto, sem interromper a fluidez da conversa. O formato do feedback deve ser similar ao exemplo dado.",
    "A correção deve ser feita em HTML, destacando a parte errada com a tag <span class="wrong"> e a parte correta com <span class="right">.",
    "Retorne apenas um JSON válido, sem explicações adicionais."
  ],
  "output_format": {
    "suggestion": "HTML da correção"
  },
  "examples": [
    {
      "input": "I choose to be to to code because if I'm if I I will work on something.",
      "output": "<span class='comparison-container'>I <span class='wrong'>choose</span> <span class='right'>chose</span> to code because...</span>"
    },
    {
      "input": "Últimas mensagens:\n- Where were you?\n- I had to do something.\nAvaliar:\n- Yes, you had.",
      "output": "<span class='comparison-container'>Yes, you <span class='wrong'>had</span> <span class='right'>did</span>.</span>"
    },
    {
      "input": "Últimas mensagens:\n- Don't you have it?\nAvaliar:\n- I don't have.",
      "output": "I don't have <span class='comparison-container'><span class='right'>it</span>.</span>"
    }
  ]
}`,
"naturality_help":
  `{
  "description": "Encontre uma oportunidade de reescrever uma fala de uma pessoa que está aprendendo inglês para algo mais fluente e natural.",
  "instructions": [
    "Você receberá uma transcrição imperfeita do áudio da conversa. Ignore erros de digitação e repetições, pois esses são naturais na fala.",
    "O feedback deve ser curto e direto, podendo repetir parcialmente ou não a frase original. Sem interromper a fluidez da conversa. O formato do feedback deve ser similar ao exemplo dado.",
    "A correção deve ser feita em HTML, destacando a parte errada com a tag <span class="original"> e a parte nova com <span class="suggestion">.",
    "Retorne apenas um JSON válido, sem explicações adicionais."
  ],
  "output_format": {
    "suggestion": "HTML da correção"
  },
  "examples": [
    {
      "input": "Últimas mensagens: - I go to the store yesterday. Avaliar: - What did you buy?",
      "aí vc foca na frase a se avaliar 'What did you buy?' e retorna: "What <span class='comparison-container'> <span class='original'>did you buy</span> <span class='suggestion'>got</span>?"
    },
    {
      "input": "Últimas mensagens: - Why I didn't see you yesterday? Avaliar: - I woke up really bad with headache and some pain in stomach.",
      "percebe que aqui ele podia ter usado uma expressão melhor e retorna: "<span class='comparison-container'> <span class='suggestion'>I was under the weather.</span>"
    },
  ]
}`,

};

export const getRandomPrompt = () => prompts[0]
